const MoreIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.3335 13.3333C5.6835 13.3333 4.3335 14.6833 4.3335 16.3333C4.3335 17.9833 5.6835 19.3333 7.3335 19.3333C8.9835 19.3333 10.3335 17.9833 10.3335 16.3333C10.3335 14.6833 8.9835 13.3333 7.3335 13.3333ZM25.3335 13.3333C23.6835 13.3333 22.3335 14.6833 22.3335 16.3333C22.3335 17.9833 23.6835 19.3333 25.3335 19.3333C26.9835 19.3333 28.3335 17.9833 28.3335 16.3333C28.3335 14.6833 26.9835 13.3333 25.3335 13.3333ZM16.3335 13.3333C14.6835 13.3333 13.3335 14.6833 13.3335 16.3333C13.3335 17.9833 14.6835 19.3333 16.3335 19.3333C17.9835 19.3333 19.3335 17.9833 19.3335 16.3333C19.3335 14.6833 17.9835 13.3333 16.3335 13.3333Z"
        fill={fill}
      />
    </svg>
  );
};
export default MoreIcon;
